// Pure readiness math for the Property Setup Board — over the same six triage
// predicates the review modal and status card use (single source of truth in
// propertyReviewQueue.js / PropertyReviewStatusCard.js).
import { TRIAGE_FILTERS } from '../../PropertyDetail/propertyReviewQueue'
import { CHECK_ROWS } from '../../PropertyDetail/PropertyReviewStatusCard'

export const SETUP_CHECKS = CHECK_ROWS

const CHECK_COUNT = TRIAGE_FILTERS.length

export const getFailingKeys = (property = {}) =>
  TRIAGE_FILTERS.filter(f => f.test(property)).map(f => f.key)

// Portfolio rollup for the dashboard band:
// - fullyReady / fullyReadyPct: properties passing all six checks
// - overallPct: passing checks across the whole portfolio (progress feel)
// - failingCounts: per-check failing property counts (tile badges)
export const computeSetupStats = (properties = []) => {
  const failingCounts = Object.fromEntries(TRIAGE_FILTERS.map(f => [f.key, 0]))
  let fullyReady = 0
  let failingChecks = 0
  properties.forEach(property => {
    const failing = getFailingKeys(property)
    failingChecks += failing.length
    if (failing.length === 0) fullyReady += 1
    failing.forEach(key => { failingCounts[key] += 1 })
  })
  const total = properties.length
  const totalChecks = total * CHECK_COUNT
  return {
    total,
    fullyReady,
    fullyReadyPct: total ? Math.round((fullyReady / total) * 100) : 0,
    overallPct: totalChecks ? Math.round(((totalChecks - failingChecks) / totalChecks) * 100) : 0,
    failingCounts
  }
}
